export class BankBalancePublicUriService {
  getLatestBankBalanceUri(asiakasAvain: string, iban: string) {
    return 'customers/' + asiakasAvain + '/bank-balances-latest/' + asiakasAvain + '_' + iban
  }
}
